import { ApiMethods } from "../../constants/apiMethods";
import { IUserSignup } from "../../pages/login/container";
import { apiFetchOAuthWithClaims } from "../../services/apiClient";

const baseURL = process.env.REACT_APP_API_URL;

export class UserApi {
    async getUserClaims(form: IUserSignup): Promise<any> {
        const url = `${baseURL}/users/me/claims?organizationId=${form.organizationId}&phone=${form.phoneNumber}`;
        return apiFetchOAuthWithClaims(ApiMethods.GET, url).withBody({}).execute<any>();
    }

    async registerUserNotification(token: string): Promise<any> {
        const url = `${baseURL}/users/me/notifications/register`;
        return apiFetchOAuthWithClaims(ApiMethods.POST, url).withBody({ platformRegistrationId: token }).execute<any>();
    }

    async unregisterUserNotification(token: string): Promise<any> {
        const url = `${baseURL}/users/me/notifications/unregister`;
        return apiFetchOAuthWithClaims(ApiMethods.POST, url).withBody({ platformRegistrationId: token }).execute<any>();
    }
}
